<template>
	<div>
		<div class="top">
			<div class="title">我的购物车</div>
			<div class="search-box">
				<div class="search">
					<el-input placeholder="作品名称编号" v-model="key_words">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
					<el-button type="warning" style="margin-left: 33px" @click="search">搜索</el-button>
				</div>
				<div class="partition">
					<div class="partition-text">选择分区</div>
					<el-select v-model="type" placeholder="请选择" @change="change">
						<el-option :label="item.typename" :value="item.id" v-for="(item,index) in cate"
							:key="index"></el-option>
					</el-select>
				</div>
				<div class="del" style="padding-right: 41px">
					<img src="@/assets/del.png" style="cursor: pointer" alt="" @click="del" />
				</div>
			</div>
			<div class="content" style="margin-top: 36px">
				<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
					:row-key="getRowKey" @selection-change="handleSelectionChange">
					<el-table-column type="selection" :reserve-selection="true" width="55" align="center">
					</el-table-column>
					<el-table-column label="作品展示图" width="120" align="center">
						<template slot-scope="scope">
							<img style="width: 54px; height: 54px; border-radius: 4px" :src="imageUrl(scope.row.litpic)"
								alt="" />
						</template>
					</el-table-column>
					<el-table-column prop="title" label="名称" width="120" align="center">
					</el-table-column>
					<el-table-column prop="product_id" label="编号" show-overflow-tooltip align="center">
					</el-table-column>
					<el-table-column prop="method" label="购买方式" show-overflow-tooltip align="center">
					</el-table-column>
					<el-table-column prop="cost" label="价格" show-overflow-tooltip align="center">
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button size="mini" type="danger"
								@click="handleDelete(scope.$index, scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="car-info">
					<div class="car-text"> 合计<span style="font-size: 20px; color: #e66617">￥{{ money }}</span>
					</div>
					<div class="buy" @click="down" :style="shopActive == '' ?'background: #333;':''">一键下载</div>
					<div class="buy" @click="settle" :style="shopActive == '' ?'background: #333;':''">立即购买</div>
				</div>
			</div>
			<div class="page-box">
				<div class="pages">
					<el-pagination @current-change="handleCurrentChange" :page-size="size"
						layout="total, prev, pager, next" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
		<loading ref="loading"></loading>
		<!-- 购买弹窗 -->
		<el-dialog title="提示" :visible.sync="buyShow" width="25%" center class="new-car">
			<el-divider></el-divider>
			<div class="govip">确定结算吗?</div>
			<div class="offline">
				<!--  通联支付 -->
				<div @click="choose('tlwechat')">
					<img src="../../assets/wx1.png" alt="" v-if="selectedMethod === 'tlwechat'" />
					<img src="../../assets/wx2.png" alt="" v-else />
				</div>
				<div @click="choose('tlalipay')">
					<img src="../../assets/zfb1.png" alt="" v-if="selectedMethod === 'tlalipay'" />
					<img src="../../assets/zfb2.png" alt="" v-else />
				</div>
				<!--        <div @click="choose('tlunion')">-->
				<!--          <img src="../../assets/ysf1.png" alt="" v-if="selectedMethod === 'tlunion'" />-->
				<!--          <img src="../../assets/ysf2.png" alt="" v-else />-->
				<!--        </div>-->
				<div @click="choose('balance')">
					<img src="../../assets/balance1.png" alt="" v-if="selectedMethod === 'balance'" />
					<img src="../../assets/balance2.png" alt="" v-else />
				</div>
				<!--  end -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="buy" style="background: #09253d; border: none; width: 120px">确 定
				</el-button>
				<el-button @click="buyShow = false" style="
				background: #c92323;
				color: #ffffff;
				border: none;
				width: 120px;
				margin-left: 94px;
			  ">取 消</el-button>
			</span>
		</el-dialog>
		<!-- 支付弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="bounced" width="20%" :close-on-click-modal="isClose" center
			class="qr_new">
			<vue-qr style="margin: 0 auto" :text="downloadData.url" :margin="0" colorDark="black" colorLight="#fff"
				:size="200"></vue-qr>
		</el-dialog>
	</div>
</template>
<script>
	import {
		userCart,
		joinCart,
		cartSourceDetailorder,
		topCate,
		cartCheckUserOrder,
		cartCheckUserOrders,
		downloadArchives,
		sourceDetailorder,
		pay_tonglian,
		select_pay_method,
		order_pay_polling
	} from "../../request/api";
	import Loading from "../../components/loading.vue";
	import vueQr from "vue-qr";
	export default {
		components: {
			Loading,
			vueQr,
		},
		data() {
			return {
				tableData: [],
				multipleSelection: [],
				key_words: "", //作品名称编号搜索
				type: "", //所属区域
				count: 1,
				size: 4,
				page: 1,
				money: 0, //总价钱
				chooseList: [], //选中列表
				shopActive: "",
				cate: '',
				buyShow: false,
				selectedMethod: "",
				dialogTitle: "打开微信扫一扫，向我付款", // 默认标题
				bounced: false, //充值弹框
				isClose: false,
				downloadData: {
					url: "扫码访问的链接地址",
					icon: "随便一张图片的地址也行",
				},
				orderInfo: {
					unified_id: "",
					unified_number: "",
				},
			};
		},
		created() {
			document.title = '以图绘图印花设计网-购物车';
			this.getUserCart()
			this.getCata()
		},
		mounted() {
			this.$loading = this.$refs.loading
		},
		methods: {
			getRowKey(row) {
				return row.product_id
			},
			//获取顶部分区
			getCata() {
				topCate().then((res) => {
					console.log(res);
					this.cate = res.data;
				});
			},
			//
			getUserCart() {
				userCart({
					key_words: this.key_words,
					type: this.type,
					page: this.page,
					size: this.size,
				}).then((res) => {
					if (res.code == 200) {
						console.log(res.data)
						this.tableData = res.data.cartInfo;
						this.count = res.data.count;
					}
				});
			},
			//多选
			handleSelectionChange(val) {
				// val.forEach(a=> {
				// 	this.chooseList.push(a)
				// })
				//  console.log(this.chooseList);
				//  return;
				this.shopActive = val.map((i, index, item) => {
					return item[index].product_id;
				});
				this.multipleSelection = val.map((i, index, item) => {
					return item[index].cart_id;
				});
				var money = 0;
				for (var i = 0; i < val.length; i++) {
					money += Number(val[i].cost);
				}
				this.money = money;
			},
			//分页
			handleCurrentChange(val) {
				this.page = val;
				this.getUserCart();
			},
			//单删
			handleDelete(index, row) {
				console.log(row.cart_id);
				joinCart({
					cart_id: row.cart_id,
				}).then((res) => {
					console.log(res);
					if (res.code == 200) {
						this.$message({
							message: "操作成功",
							type: "success",
						});
						this.getUserCart();
					}
				});
			},
			//多删
			del() {
				if (this.multipleSelection == '') return
				joinCart({
					cart_id: this.multipleSelection.toString(),
				}).then((res) => {
					console.log(res);
					if (res.code == 200) {
						this.$message({
							message: "操作成功",
							type: "success",
						});
						this.getUserCart();
					}
				});
			},
			//搜索
			search() {
				this.getUserCart();
			},
			//分区搜索
			change() {
				this.getUserCart();
			},
			//使用免费次数一键下载
			down() {
				if (this.shopActive == '' || this.shopActive == null) return
				var that = this
				this.$loading.show()
				cartCheckUserOrder({
					card_id: this.shopActive.toString(),
				}).then((res) => {
					if (res.code == 300) {
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							cartCheckUserOrders({
								card_id: this.shopActive.toString(),
							}).then((res) => {
								if (res.code == 200) {
									//下载
									window.open("/api/newapi/BuyOrder/downloadArchives", "_self")
									setTimeout(function() {
										that.$message.success("开始下载");
										that.$loading.hide()
									}, 12000);
									// downloadArchives({
									// 	card_id: this.shopActive.toString(),
									// }).then((res) => {
									// 	const blob = new Blob([res]);
									// 	const fileName = '素材.zip';
									// 	if ("msSaveOrOpenBlob" in navigator) return window.navigator.msSaveOrOpenBlob(blob, fileName);
									// 	const blobUrl = window.URL.createObjectURL(blob);
									// 	const exportFile = document.createElement("a");
									// 	exportFile.style.display = "none";
									// 	exportFile.download = fileName;
									// 	exportFile.href = blobUrl;
									// 	document.body.appendChild(exportFile);
									// 	exportFile.click();
									// 	// 去除下载对 url 的影响
									// 	document.body.removeChild(exportFile);
									// 	window.URL.revokeObjectURL(blobUrl);
									// 	this.$message.success("下载完成");
									// 	this.$loading.hide()
									// });
								} else {
									this.$message.error(res.msg);
									this.$loading.hide()
								}
							});
						}).catch(() => {
							this.$loading.hide()
						});
					} else if (res.code == 505) {
						that.$loading.hide()
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							this.$router.push("/seller/sellerInfo");
						})
					} else {
						this.$message.error(res.msg);
						this.$loading.hide()
					}
				});
			},
			//结算
			settle() {
				if (this.shopActive == '' || this.shopActive == null) return
				this.buyShow = !this.buyShow;
			},
			choose(method) {
				if (this.selectedMethod === method) {
					// 再次点击已选中的支付方式可取消选择
					this.selectedMethod = "";
				} else {
					this.selectedMethod = method;
				}
				if (this.selectedMethod === 'tlwechat') {
					this.dialogTitle = '打开微信扫一扫，向我付款';
				} else if (this.selectedMethod === 'tlalipay') {
					this.dialogTitle = '打开支付宝扫一扫，向我付款';
				} else if (this.selectedMethod === 'tlunion') {
					this.dialogTitle = '打开云闪付扫一扫，向我付款';
				} else {
					this.dialogTitle = '扫码支付';
				}
			},
			buy() {
				if (!this.selectedMethod) {
					this.$message.error("请选择支付方式");
					return;
				}
				cartSourceDetailorder({
					card_id: this.shopActive.toString(),
					payment: this.selectedMethod
				}).then((res) => {
					if (res.code == 200) {
						if (this.selectedMethod === 'balance') {
							this.$message({
								message: res.msg,
								type: "success",
							});
							this.buyShow = false;
							this.$router.go(0)
						} else {
							this.orderInfo.unified_id = res.data.order_id;
							this.orderInfo.unified_number = res.data.order_code;
							pay_tonglian({
								unified_number: this.orderInfo.unified_number,
								transaction_type: 10,
								payment: this.selectedMethod
							}).then((res) => {
								if (res.code == 200) {
									this.buyShow = false;
									this.downloadData.url = res.data;
									this.bounced = true;
									this.getSelect_pay_method();
								} else {
									this.$message.error(res.msg);
								}
							});
						}
					} else if (res.code == 505) {
						this.$confirm(res.msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(() => {
							this.$router.push("/seller/sellerInfo");
						})
					} else {
						this.$message.error(res.msg)
						this.buyShow = false;
					}
				});
			},
			//支付接口列表
			getSelect_pay_method() {
				select_pay_method({
					unified_id: this.orderInfo.unified_id,
					unified_number: this.orderInfo.unified_number,
					transaction_type: 10,
					// pay_mark: "wechat",
					// pay_id: 1,
					pay_mark: "allinpay",
					pay_id: 3,
				}).then((res) => {
					if (res.code == 200) {
						this.order_pay();
					} else {
						this.$message.error(res.msg);
						this.bounced = false;
					}
				});
			},
			//订单支付轮询
			order_pay() {
				var time = setInterval(() => {
					order_pay_polling({
						unified_id: this.orderInfo.unified_id,
						unified_number: this.orderInfo.unified_number,
						transaction_type: 10,
						// pay_mark: "wechat",
						// pay_id: 1,
						pay_mark: "allinpay",
						pay_id: 3,
					}).then((res) => {
						console.log("222", res);
						if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: "success",
							});
							this.buyShow = false;
							this.bounced = false;
							clearInterval(time);
							this.$router.go(0);
						}
					});
				}, 2000);
			},
			//结算
			settle1() {
				if (this.shopActive == '' || this.shopActive == null) return
				this.$confirm("确定结算吗", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					cartSourceDetailorder({
						card_id: this.shopActive.toString(),
					}).then((res) => {
						console.log(res);
						if (res.code == 200) {
							this.$message({
								message: res.msg,
								type: "success",
							});
							this.$router.go(0)
						} else if (res.code == 505) {
							this.$confirm(res.msg, {
								confirmButtonText: "确定",
								cancelButtonText: "取消",
								type: "warning",
							}).then(() => {
								this.$router.push("/seller/sellerInfo");
							})
						} else {
							this.$message.error(res.msg);
						}
					});
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	.top {
		background: #ffffff;
		border-radius: 6px;
		padding: 34px 23px 0 23px;

		.title {
			font-size: 20px;
			font-weight: 400;
			color: #08243c;
			line-height: 20px;
		}

		.title::after {
			content: "";
			width: 100px;
			height: 9px;
			background: #e66617;
			display: block;
			margin-top: -8px;
		}

		.search-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 29px;

			.search {
				display: flex;
			}

			.partition {
				display: flex;
				align-items: center;

				.partition-text {
					font-size: 16px;
					font-weight: 400;
					color: #000000;
					line-height: 16px;
					padding-right: 29px;
				}
			}
		}

		.content {
			.car-info {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				margin-top: 80px;

				.car-text {
					font-size: 16px;
					font-weight: 400;
					color: #000000;
					line-height: 16px;
				}

				.buy {
					width: 100px;
					height: 36px;
					background: #e66617;
					border-radius: 4px;
					margin-left: 66px;
					font-size: 16px;
					text-align: center;
					font-weight: 400;
					color: #ffffff;
					line-height: 36px;
					cursor: pointer;
				}
			}
		}
	}

	/deep/.el-table th {
		background: rgba(8, 36, 60, 0.04);
		font-size: 14px;
		font-weight: 400;
		color: #000000;
		line-height: 36px;
	}

	/deep/.el-table td {
		padding: 25px 0;
	}

	/deep/ .el-table th {
		padding: 0;
	}

	.page-box {
		overflow: hidden;

		.pages {
			margin: 0 auto;
			display: flex;
			justify-content: flex-end;
			padding-top: 52px;
			padding-bottom: 85px;
		}
	}

	/deep/.el-pager li {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 32px;
	}

	/deep/.el-pager li.active {
		width: 32px;
		height: 32px;
		background: #08243c;
		border-radius: 50%;
	}

	/deep/.el-pager li.active {
		color: #ffffff;
	}

	/deep/.el-dialog,
	/deep/.el-pager li {
		//background: none;
	}

	/deep/.el-pagination .btn-next,
	/deep/.el-pagination .btn-prev {
		background: none;
	}

	/deep/.el-pagination .btn-next .el-icon,
	/deep/.el-pagination .btn-prev .el-icon {
		font-size: 16px;
		line-height: 32px;
	}

	.govip {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #000000;
		line-height: 18px;
		text-align: center;
		margin-top: 30px;
	}

	.offline {
		//padding: 12px;
		//font-size: 12px;
		background-color: #ffffff;
		//color: #08243c;
		display: flex;
		padding-top: 12px;
		justify-content: center;

		/* 水平居中 */
		//div:first-child {
		//  width: 25%;
		//}
		.money {
			margin-left: 18px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;

			.inputMoney {
				display: flex;
				align-items: center;

				input {
					width: 72px;
					height: 28px;
					border: 1px #cdd6de solid;
					text-align: center;
				}
			}

			.fixed {
				width: 75px;
				height: 30px;
				text-align: center;
				line-height: 30px;
				border: 1px #cdd6de solid;
				margin-bottom: 9px;
			}

			.num-active {
				background: #f6f8f9;
			}
		}

		img {
			width: 33px;
			height: 33px;
		}
	}

	.new-car /deep/.el-dialog {
		background: #FFF;
	}

	.new-car /deep/.el-dialog__body {
		padding: 0 25px 30px;
	}

	.new-car /deep/.el-dialog__body img {
		display: flex;
		justify-content: center;
	}
</style>